export default __webpack_public_path__ + "assets/images/Arrow Down-5b4e4876bc815bb0d925c33b651c5b97.svg";